import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import EditActionButtons from "./EditActionButtons";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  GRADIENT_BLACK_COLOR,
  BOX_SHADOW_BUTTON_CARD,
  WHITE_COLOR,
} from "../../../../utils/colors";
import { useBrandSetupReadOnly } from "../context/brandSetupReadOnlyContext";

export const SectionHeader = ({
  icon: Icon,
  sxIcon = {},
  title,
  subtitle,
  subtitleCount,
  subtitleCountKeySingular,
  subtitleCountKeyPlural,
  isEditing,
  onEdit,
  onSave,
  editButtonProps = {},
  rightAction,
  actionButton = false,
  actionButtonDisabled = false,
  onActionButtonClick,
  actionButtonIcon: ActionButtonIcon = AddIcon,
  actionButtonSx = {},
}) => {
  const { t } = useTranslationApp();
  const readOnly = useBrandSetupReadOnly();

  const getSubtitleText = () => {
    if (subtitleCount !== undefined && subtitleCount !== null) {
      const countKey =
        subtitleCount === 1 ? subtitleCountKeySingular : subtitleCountKeyPlural;
      return `${subtitleCount} ${t(countKey)}`;
    }
    if (subtitle) {
      return t(subtitle);
    }
    return null;
  };

  const subtitleText = getSubtitleText();

  const renderRightAction = () => {
    if (readOnly) {
      return null;
    }

    if (rightAction) {
      return rightAction;
    }
    if (isEditing !== undefined && onEdit && onSave) {
      return (
        <EditActionButtons
          isEditing={isEditing}
          onEdit={onEdit}
          onSave={onSave}
          {...editButtonProps}
        />
      );
    }
    if (actionButton) {
      return (
        <IconButton
          size="small"
          onClick={onActionButtonClick}
          disabled={actionButtonDisabled}
          sx={{
            color: "text.primary",
            opacity: actionButtonDisabled ? 0.55 : 1,
            "&:hover": {
              backgroundColor: "action.hover",
            },
            ...actionButtonSx,
          }}
        >
          <ActionButtonIcon fontSize="small" />
        </IconButton>
      );
    }
    return null;
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 1,
        pb: 1,
        minHeight: 40,
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, flex: 1 }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 4,
            backgroundImage: GRADIENT_BLACK_COLOR,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            color: "#fff",
            boxShadow: BOX_SHADOW_BUTTON_CARD,
          }}
        >
          <Icon
            sx={{
              width: 24,
              height: 24,
              color: `${WHITE_COLOR} !important`,
              ...sxIcon,
            }}
            htmlColor={WHITE_COLOR}
          />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "text.primary",
              fontSize: "18px",
              lineHeight: "24px",
              wordBreak: "break-word",
              mb: 0.3,
            }}
          >
            {t(title)}
          </Typography>
          {subtitleText && (
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontSize: "14px",
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {subtitleText}
            </Typography>
          )}
        </Box>
      </Box>

      {renderRightAction()}
    </Box>
  );
};

export default SectionHeader;
